// styles
import './assets/styles/main.scss';

// configure language
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';

import { loadThreeflowComponents, threeflowObject } from './shared';

// utils
import Analytics from './utils/analytics';
import AxiosConfig from './utils/axios';
import Cookies from './utils/cookies';
import DatesUtils from './utils/dates';
import Formatting from './utils/formatting';
import Product from './utils/product';
import ReusableData from './utils/reusable-data';

// services
import CommentService from './services/comment';
import Interceptor from './services/interceptor';
import NotificationsService from './services/notifications';
import SourceService from './services/source';

// CP Services - temporary until carrier can create its own component library
import * as CalloutsService from './services/callouts';

const Threeflow = {
  /**
   * Install our component
   *
   * @param {object} Vue
   * @param {object} options
   */
  install(Vue, options) {
    Object.defineProperty(Vue.prototype, '$TF', { value: threeflowObject });
    Interceptor.activate(options);
    loadThreeflowComponents(Vue);
    locale.use(lang);
  },
};

export {
  Analytics,
  AxiosConfig,
  CalloutsService,
  CommentService,
  Cookies,
  DatesUtils,
  Formatting,
  NotificationsService,
  Product,
  ReusableData,
  SourceService,
  Threeflow,
  Threeflow as WatchtowerBenefits,
};
